<div class="row">
  <div class="col-4" *ngIf="title!=null"><label>{{title}}</label></div>
  <div [class.col-8]="title!=null" [class.col-12]="title==null">
    <div class="input-group input-group-sm">
      <!-- <input [(ngModel)]="dateValue" class="form-control form-control-sm" [placeholder]="title || 'Date'"
             [style.backgroundColor]="disabled ? 'lightgray' : null" [nbDatepicker]="formpicker" [attr.disabled]="disabled ? '' : null"> -->
      <input [(ngModel)]="dateModel" class="form-control form-control-sm datepicker" [placeholder]="title || 'Date'"
             [style.backgroundColor]="disabled ? 'lightgray' : null"
             ngbDatepicker [disabled]="disabled" [footerTemplate]="today" #d="ngbDatepicker" (click)="d.toggle()" (dateSelect)="updateDate($event)">

      <div *ngIf="!disabled" class="input-group-append">
        <button class="nrk-doc-button" (click)="clear()">X</button>
      </div>
      <!-- <nb-datepicker #formpicker (dateChange)="update($event)" [date]="dateValue" format="yyyy-MM-dd"></nb-datepicker> -->
    </div>
  </div>
</div>

<ng-template #today>
  <div style="text-align:center;margin-bottom:5px;"><button class="nrk-button" (click)="emitDate()">Today</button></div>
</ng-template>

